module.exports = {
  returnName: {
    1: 'Enviado',
    2: 'Pendente',
    3: 'Em_Exportacao',
    4: 'ProcessadoErro',
    5: 'ProcessadoSucesso',
    6: 'Reenviado',
    7: 'Excluida',
    8: 'ComErro' || 'ErroExportacao',
    9: 'EmEspera' || 'AguardandoDownload',
    10: 'Pendente' || 'PendenteProcessamento',
    11: 'ComErro' || 'ErroValidacao',
    12: 'EmValidacao',
    13: 'EmEspera' || 'AguardandoDocumentos',
    14: 'ProcessadaParcialmente',
    15: 'Registrada',
    16: 'EmAnalisedeDocumentacao',
  },

  returnNameFormatted: {
    1: 'Enviado',
    2: 'Pendente de Envio',
    3: 'Em Exportacão',
    4: 'Erro de Processamento',
    5: 'Processada c/ Sucesso',
    6: 'Reenviado',
    7: 'Excluida',
    8: 'Erro ao Exportar',
    9: 'Aguardando Download',
    10: 'Pendente de Processamento',
    11: 'Erro de Validação',
    12: 'Em Validação',
    13: 'Aguardando Documentos',
    14: 'Processada parcialmente',
    15: 'Registrada',
    16: 'Em Análise de Documentação',
  },
  returnId: {
    Enviado: 1,
    PendentedeEnvio: 2,
    EmExportacao: 3,
    ErrodeProcessamento: 4,
    ProcessadoSucesso: 5,
    Reenviado: 6,
    Excluida: 7,
    ErroExportacao: 8,
    AguardandoDownload: 9,
    PendenteProcessamento: 10,
    ErroValidacao: 11,
    EmValidacao: 12,
    AguardandoDocumentos: 13,
    ProcessadaParcialmente: 14,
    Registrada: 15,
    EmAnalisedeDocumentacao: 16,
  },
  returnNameForName: {
    Enviado: 'Enviado',
    PendentedeEnvio: 'PendentedeEnvio',
    EmExportacao: 'EmExportacao',
    ErrodeProcessamento: 'ErrodeProcessamento',
    ProcessadoSucesso: 'ProcessadoSucesso',
    Reenviado: 'Reenviado',
    Excluida: 'Excluida',
    ErroExportacao: 'ErroExportacao',
    AguardandoDownload: 'AguardandoDownload',
    PendenteProcessamento: 'PendenteProcessamento',
    ComErro: 'ErroValidacao',
    EmValidacao: 'EmValidacao',
    AguardandoDocumentos: 'AguardandoDocumentos',
    ProcessadaParcialmente: 'ProcessadaParcialmente',
    Registrada: 'Registrada',
    EmAnalisedeDocumentacao: 'Em Análise de Documentação',
  },
  returnNameForTab: {
    Todas: 0,
    // Registrada: [1, 15],
    // Enviado: 1,
    EmValidacao: 12,
    Pendente: [2, 10],
    EmEspera: [3, 9, 13],
    Processada: [5, 14],
    ComErro: [4, 8, 11],
    Excluida: 7,
    // Reenviado: 6,
  },
  returnTabForName: {
    Todas: 'Todas',
    Registrada: 'Registrada',
    EmValidacao: 'EmValidacao',
    Pendente: 'Pendente',
    EmEspera: 'EmEspera',
    // Enviado: 'Enviado',
    Processada: 'Processada',
    ComErro: 'ComErro',
    Excluida: 'Excluida',
  },
};
